import React from 'react';
import { Container } from 'reactstrap';
import logo from "../../img/indexAR-logo-white.png";

// import Breadcrumbs from 'react-router-breadcrumbs'
// import { routes } from './../../App'

export default function RegisterHeader() {

  return (
    <div className="mai-sub-header mai-sub-header-register">
      <Container className="d-flex align-items-center justify-content-between p-0">
        <img src={logo} width="50" height="45" className="register-header-logo" alt="" />
        <p className="register-header-text">Just a few more informations and we’re done!</p>
      </Container>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Register/Header.js